module.exports = __webpack_public_path__ + "img/lang-21.ac0071c8.jpg";